/**
 * The api's addresses. Subdomain-first: the api lives on its own host
 * in every deployed environment; localhost only as the dev default.
 */
export const API_BASE =
  import.meta.env.VITE_API_BASE ?? "http://localhost:8000";
// The stream rides the API's own origin unless told otherwise: a hand-set port drifted to 8000 while the
// API ran on 8001, and every page logged a failed socket (2026-09-17).
export const WS_URL =
  import.meta.env.VITE_WS_URL ?? `${API_BASE.replace(/^http/, "ws")}/ws/events`;

/**
 * A refusal the SERVER made, carrying its status.
 *
 * A rejected query otherwise says only that something went wrong, and the shell reported every
 * one as an unreachable server (2026-09-11) -- so an expired token or an account with no
 * membership read as a network fault, which is the one thing the reader cannot act on.
 */
export class RequestRefused extends Error {
  // Declared, then assigned: a constructor parameter property is not erasable syntax, and the
  // build's erasableSyntaxOnly refused the file (found 2026-09-13 on the first typecheck since).
  readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = "RequestRefused";
    this.status = status;
  }

  /** Whether the server refused the CALLER rather than the request: sign-in or membership. */
  get isIdentity(): boolean {
    return this.status === 401 || this.status === 403;
  }
}
